import { createReducer } from 'helpers/redux';
import cloneDeep from 'lodash.clonedeep';
import {
  SET_ACTIVE_FILTER,
  SET_VIEW,
  SET_SORT,
  SET_RESULTS,
  LOAD_MORE,
  SET_FILTER_RANGE,
  SET_FILTER_CHOICE,
  TOGGLE_FILTER_MONTHLY,
  SET_GENRE,
  SET_FILTER_VALUES,
  RESET_FILTER,
  CLEAR_FILTERS,
  OPEN_FILTERS_MODAL,
  CLOSE_FILTERS_MODAL,
  APPLY_FILTERS,
  SET_FEATURE_CARDS,
} from './types';

export const initialState = {
  activeFilterId: null,
  view: 'grid',
  sort: '',
  results: [],
  genreCards: {},
  familyCards: {},
  page: 1,
  genre: null,
  cachedFilters: {},
  filters: {},
  filtersOpen: false,
};

const bikesReducer = createReducer({
  initialState,
  reducers: {
    [SET_ACTIVE_FILTER]: (state, action) => ({
      ...state,
      activeFilterId: action.payload,
    }),
    [SET_VIEW]: (state, action) => ({
      ...state,
      view: action.payload,
    }),
    [SET_SORT]: (state, action) => ({
      ...state,
      sort: action.payload,
    }),
    [SET_RESULTS]: (state, { payload: results }) => ({
      ...state,
      results,
      page: 1,
    }),
    [LOAD_MORE]: state => ({
      ...state,
      page: state.page + 1,
    }),
    [SET_FILTER_RANGE]: (state, { payload: { filter, from, to } }) => ({
      ...state,
      filters: {
        ...state.filters,
        [filter]: {
          ...state.filters[filter],
          from: typeof from !== 'undefined' ? from : state.filters[filter].from,
          to: typeof to !== 'undefined' ? to : state.filters[filter].to,
        },
      },
    }),
    [SET_FILTER_CHOICE]: (state, { payload: { filter, choice } }) => ({
      ...state,
      filters: {
        ...state.filters,
        [filter]: {
          ...state.filters[filter],
          choice,
        },
      },
    }),
    [TOGGLE_FILTER_MONTHLY]: (state, { payload: filter }) => ({
      ...state,
      filters: {
        ...state.filters,
        [filter]: {
          ...state.filters[filter],
          monthly: !state.filters[filter].monthly,
        },
      },
    }),
    [SET_GENRE]: (state, action) => ({
      ...state,
      genre: action.payload,
    }),
    [SET_FILTER_VALUES]: (state, { payload: filters }) => ({
      ...state,
      filters: filters.reduce((prevFilters, filter, index) => {
        prevFilters[index] = {};

        if (filter.type === 'slider') {
          const min = filter.values.length ? parseInt(filter.values[0].value, 10) : 0;
          const max = filter.values.length ? parseInt(filter.values[filter.values.length - 1].value, 10) : 0;

          prevFilters[index].min = min;
          prevFilters[index].max = max;
          prevFilters[index].from = min;
          prevFilters[index].to = max;
        }

        if (filter.type === 'options') {
          prevFilters[index].choice = null;
        }

        return prevFilters;
      }, {}),
    }),
    [RESET_FILTER]: (state, { payload: filterIndex }) => {
      const filter = state.filters[filterIndex];

      // range
      if (typeof filter.min !== 'undefined') {
        return {
          ...state,
          filters: {
            ...state.filters,
            [filterIndex]: {
              ...state.filters[filterIndex],
              from: filter.min,
              to: filter.max,
            },
          },
        };
      }

      // choice
      if (typeof filter.choice !== 'undefined') {
        return {
          ...state,
          filters: {
            ...state.filters,
            [filterIndex]: {
              ...state.filters[filterIndex],
              choice: null,
            },
          },
        };
      }
    },
    [CLEAR_FILTERS]: state => ({
      ...state,
      filters: Object.entries(state.filters).reduce((prevFilters, [filterIndex, filter]) => {
        if (typeof filter.min !== 'undefined') {
          return {
            ...prevFilters,
            [filterIndex]: {
              ...filter,
              from: filter.min,
              to: filter.max,
            },
          };
        }

        if (typeof filter.choice !== 'undefined') {
          return {
            ...prevFilters,
            [filterIndex]: {
              ...filter,
              choice: null,
            },
          };
        }

        return {
          ...prevFilters,
        };
      }, {}),
    }),
    [OPEN_FILTERS_MODAL]: state => ({
      ...state,
      cachedFilters: cloneDeep(state.filters),
      filtersOpen: true,
    }),
    [CLOSE_FILTERS_MODAL]: state => ({
      ...state,
      filters: state.cachedFilters,
      cachedFilters: null,
      filtersOpen: false,
    }),
    [APPLY_FILTERS]: state => ({
      ...state,
      cachedFilters: null,
      filtersOpen: false,
    }),
    [SET_FEATURE_CARDS]: (state, { payload: { type, features } }) => ({
      ...state,
      [type === 'genre' ? 'genreCards' : 'familyCards']: features.reduce(
        (prevFeatures, feature) => ({
          ...prevFeatures,
          [feature.id]: feature.cards,
        }),
        {}
      ),
    }),
  },
});

export default bikesReducer;
